import { Button } from "@/components/clickable";
import { cx } from "@/utils";

export default function PaginationButton({
  page,
  onClick,
  className,
  children,
  disabled = false,
}) {
  return (
    <Button
      onClick={() => onClick(page)}
      className={cx("flex items-center font-normal", className)}
      disabled={disabled}
      color="light"
      plain
    >
      {children}
    </Button>
  );
}
